import clsx from 'clsx';
import { Dispatch, SetStateAction, useContext, useEffect } from 'react';
import { twMerge } from 'tailwind-merge';

import { LocaleContext } from '../Layout';

type Props = {
  darkBg: boolean;
  open: boolean;
  setOpen: Dispatch<SetStateAction<boolean>>;
};

const Bar = ({ className }: { className?: string }) => (
  <div className={twMerge('mx-0 my-6 h-2 bg-grey-500 transition-transform duration-[0.12s] ease-out', className)} />
);

export const MobileHamburgerMenuButton = ({ darkBg, open, setOpen }: Props) => {
  const locale = useContext(LocaleContext);

  const handleToggleMenu = (val: boolean) => {
    // Prevent page scrolling when the menu is open
    document.body.style.overflow = val ? 'hidden' : 'auto';
    setOpen(val);
  };

  useEffect(() => {
    return () => {
      document.body.style.overflow = 'auto';
    };
  }, []);

  return (
    <button
      aria-label={
        {
          en: `Button to open the main navigation menu`,
          fr: `Bouton pour ouvrir le menu de navigation principal`,
        }[locale]
      }
      onClick={() => handleToggleMenu(!open)}
      className="ml-16 block -scale-x-100 cursor-pointer border-none bg-transparent lg:hidden"
    >
      <Bar
        className={twMerge(
          clsx('w-20 origin-top-left rotate-0', open && 'w-24 rotate-45 ease-in-out', darkBg && 'bg-white'),
        )}
      />
      <Bar
        className={twMerge(
          clsx('w-20 opacity-100 transition-opacity', open && 'opacity-0 ease-in-out', darkBg && 'bg-white'),
        )}
      />
      <Bar
        className={twMerge(
          clsx('w-16 origin-bottom-left rotate-0', open && 'w-24 -rotate-45 ease-in-out', darkBg && 'bg-white'),
        )}
      />
    </button>
  );
};
